import { RestClient } from '..';
import { API } from './utils';

export const TripClient = (): any => {
  const { get, patch, deleteRequest } = RestClient();
  const getTripAll = () => get({url: API + 'trip'});
  const getPaginatedTrips = (page: number, pageSize: number, shifterId?: any, params?: any) => get({url: API +
    `trip?pageNumber=${page}&pageSize=${pageSize}` +
    `${shifterId ? '&shifterId=' + shifterId : ''}` +
    `${params?.transportType ? '&transportType=' + params.transportType : ''}` +
    `${params?.actual ? '&isActual=' + params.actual : ''}` +
    `${params?.paymentStatus > -1 ? '&offerPaymentStatus=' + params.paymentStatus : ''}` +
    `${params?.createdOnFrom ? '&creationDateFrom=' + params.createdOnFrom : ''}` +
    `${params?.createdOnTo ? '&creationDateTo=' + params.createdOnTo : ''}` +
    `${params?.startDateFrom ? '&tripStartDateFrom=' + params.startDateFrom : ''}` +
    `${params?.startDateTo ? '&tripStartDateTo=' + params.startDateTo : ''}` +
    `${params?.endDateFrom ? '&tripEndDateFrom=' + params.endDateFrom : ''}` +
    `${params?.endDateTo ? '&tripEndDateTo=' + params.endDateTo : ''}` +
    `${params?.fromPlaceId ? '&fromPlaceId=' + params.fromPlaceId : ''}` +
    `${params?.toPlaceId ? '&toPlaceId=' + params.toPlaceId : ''}` +
    `${params?.phoneNumber ? '&phone=' + params.phoneNumber : ''}`
  });
  const getTripInventoryById = (tripId: number) => get({url: API + `trip/inventory?tripId=${tripId}`});
  const changeActualTrip = (tripId: number, data: any) => patch({url: API + `trip/${tripId}`, body: data});
  const getTripById = (tripId: number) => get({url: API + `trip/${tripId}`});
  const getReviewsByTripId = (tripId: number) => get({url: API + `rating?tripId=${tripId}`});
  const getOffersByTripId = (tripId: number) => get({url: API + `offer/search?tripId=${tripId}`});
  const removeTrip = (tripId: number) => deleteRequest({url: API + `trip/admin/${tripId}`});

  return {
    getTripAll,
    getPaginatedTrips,
    changeActualTrip,
    getTripById,
    getTripInventoryById,
    getReviewsByTripId,
    getOffersByTripId,
    removeTrip
  };
};

export const ParcelClient = (): any => {
  const { get, patch, deleteRequest } = RestClient();
  const getParcelAll = () => get({url: API + 'parcel'});
  const getPaginatedParcels = (page: number, pageSize: number, clientId?: any, params?: any) => get({url: API +
    `parcel?pageNumber=${page}&pageSize=${pageSize}` +
    `${clientId ? '&userId=' + clientId : ''}` +
    `${params?.isActual ? '&isActual=' + params.isActual : ''}` +
    `${params?.parcelSumFrom ? '&fromPrice=' + params.parcelSumFrom : ''}` +
    `${params?.parcelSumTo ? '&toPrice=' + params.parcelSumTo : ''}` +
    `${params?.createdOnFrom ? '&creationDateFrom=' + params.createdOnFrom : ''}` +
    `${params?.createdOnTo ? '&creationDateTo=' + params.createdOnTo : ''}` +
    `${params?.departureDateTimeFrom ? '&offerDateFrom=' + params.departureDateTimeFrom : ''}` +
    `${params?.departureDateTimeTo ? '&offerDateTo=' + params.departureDateTimeTo : ''}` +
    `${params?.fromPlaceId ? '&fromPlaceId=' + params.fromPlaceId : ''}` +
    `${params?.toPlaceId ? '&toPlaceId=' + params.toPlaceId : ''}` +
    `${params?.deliveryStatus ? '&deliveryStatus=' + params.deliveryStatus : ''}` +
    `${params?.baggageTypes ? '&baggageTypes=' + params.baggageTypes : ''}` +
    `${params?.phoneNumber ? '&phoneNumber=' + params.phoneNumber : ''}` +
    `${params?.isPremium ? '&isPremium=' + params.isPremium : ''}` +
    `${params?.isDraft === false ? '&isDraft=false' : ''}` +
    `${params?.isDraft === true ? '&isDraft=true' : ''}`
  });
  const getParcelInventoryById = (dealId: string) => get({url: API + `parcel/inventory?dealId=${dealId}`});
  const getParcelTypes = () => get({url: API + `settings/parcel-type?lang=${localStorage.getItem('language') ?? 'ru'}`});
  const editParcelById = (parcelId: number, data: any) => patch({url: API + `parcel/admin/${parcelId}`, body: data});
  const getOffersByParcelId = (parcelId: number) => get({url: API + `offer/search?parcelId=${parcelId}`});
  const getReviewsByParcelId = (parcelId: string) => get({url: API +`rating?parcelId=${parcelId}`});
  const getParcelById = (parcelId: number) => get({url: API + `parcel/admin/${parcelId}`});
  const removeParcel = (parcelId: number) => deleteRequest({url: API + `parcel/admin/${parcelId}`});

  return {
    getParcelAll,
    getPaginatedParcels,
    getParcelTypes,
    getParcelInventoryById,
    editParcelById,
    getOffersByParcelId,
    getReviewsByParcelId,
    getParcelById,
    removeParcel
  };
};

export const PayoutClient = (): any => {
  const { get, post } = RestClient();
  const getPayouts = () => get({url: API + 'parcel/payout'});
  const verifyPayout = (body: any) => post({url: API + `parcel/payout`, body: body});

  return {
    getPayouts,
    verifyPayout
  };
};

export const CarsClient = (): any => {
  const { get, deleteRequest } = RestClient();
  const getPaginatedCars = (page: number, pageSize: number, clientId?:string, params?: any) => get({url: API +
    `car?pageNumber=${page}&pageSize=${pageSize}` +
    `${clientId ? '&userId=' + clientId : ''}` +
    `${params?.brand ? '&brand=' + params.brand : ''}` +
    `${params?.model ? '&model=' + params.model : ''}` +
    `${params?.createdOnFrom ? '&createdOnFrom=' + params.createdOnFrom : ''}` +
    `${params?.createdOnTo ? '&createdOnTo=' + params.createdOnTo : ''}` +
    `${params?.verificationStatus ? '&verificationStatus=' + params.verificationStatus : ''}` +
    `${params?.clientFullName ? '&userFullName=' + params.clientFullName : ''}`
  });
  const getCarById = (id: string) => get({url: API + `car/${id}`});
  const deleteCarById = (id: string) => deleteRequest({url: API + `car?carId=${id}`});
  const getTripByCarId = (id: string) => get({url: API + `trip/by-car?carId=${id}`});

  return {
    getPaginatedCars,
    getCarById,
    deleteCarById,
    getTripByCarId
  };
};

export const Verification = (): any => {
  const { get, patch, deleteRequest } = RestClient();
  const getVerificationTrip = (page: number, pageSize: number, params?: any) => get({url: API +
    `trip-verification?pageNumber=${page}&pageSize=${pageSize}` +
    `${params?.vfStatus ? '&verificationStatus=' + params.vfStatus : ''}`
  });
  const getVerificationTripById = (id: number) => get({url: API + `trip-verification/${id}`});
  const changeVerificationTripById = (id: number, body: any) => patch({ url: API + `trip-verification/${id}`, body: body});
  const getVerificationUser = (page: number, pageSize: number, params?: any) => get({url: API +
    `user-verification?pageNumber=${page}&pageSize=${pageSize}` +
    `${params?.vfStatus ? '&verificationStatus=' + params.vfStatus : ''}`
  });
  const getVerificationCar = (page: number, pageSize: number, params?: any) => get({url: API +
    `car-verification?pageNumber=${page}&pageSize=${pageSize}` +
    `${params?.vfStatus ? '&verificationStatus=' + params.vfStatus : ''}`
  });
  const getVerificationUserById = (id: number) => get({url: API + `user-verification/${id}`});
  const changeVerificationUserById = (id: number, body: any) => patch({url: API + `user-verification/${id}`, body: body});
  const deleteVerificationUserById = (id: number) => deleteRequest({url: API + `user-verification/${id}`});
  const getVerificationCarById = (id: number) => get({url: API + `car-verification/${id}`});
  const changeVerificationCarById = (id: number, body: any) => patch({url: API + `car-verification/${id}`, body: body});

  return {
    getVerificationTrip,
    getVerificationTripById,
    changeVerificationTripById,
    getVerificationUser,
    getVerificationCar,
    getVerificationUserById,
    changeVerificationUserById,
    getVerificationCarById,
    changeVerificationCarById,
    deleteVerificationUserById
  };
};

export const BlackList = (): any => {
  const { get, post, deleteRequest } = RestClient();
  const getBlackList = () => get({url: API + `blacklist`});
  const getBlackListById = (id: number) => get({url: API + `blacklist/${id}`});
  const addUserToBlackList = (data: {reason: string, p2PUserId: number, deviceID: string}) => post({url: API + `blacklist`, body: data});
  const deleteBlackListById = (id: number) => deleteRequest({url: API + `blacklist/${id}`});

  return {
    getBlackList,
    getBlackListById,
    addUserToBlackList,
    deleteBlackListById
  };
};

export const UserClient = (): any => {
  const { get, patch, deleteRequest } = RestClient();
  const getUserAll = () => get({url: API + 'user/all'});
  const getUserById = (id: number) => get({url: API + `user/${id}`});
  const getPaginatedUsers = (page: number, pageSize: number, params?: any) => get({url: API +
    `user?pageNumber=${page}&pageSize=${pageSize}` +
    `${params?.phoneNumber ? '&phone=' + params.phoneNumber : ''}` +
    `${params?.userType ? '&accountType=' + params.userType : ''}` +
    `${params?.firstName ? '&firstName=' + params.firstName : ''}` +
    `${params?.secondName ? '&lastName=' + params.secondName : ''}` +
    `${params?.thirdName ? '&middleName=' + params.thirdName : ''}` +
    `${params?.email ? '&email=' + params.email : ''}` +
    `${params?.dateOfBirthFrom ? '&birthDateFrom=' + params.dateOfBirthFrom : ''}` +
    `${params?.dateOfBirthTo ? '&birthDateTo=' + params.dateOfBirthTo : ''}` +
    `${params?.createdOnFrom ? '&creationDateFrom=' + params.createdOnFrom : ''}` +
    `${params?.createdOnTo ? '&creationDateTo=' + params.createdOnTo : ''}`
  });
  const changeUserDetail = (id: number, data: any) => patch({url: API + `user/${id}`, body: data});
  const getRatingByUser = (id: string) => get({url: API + `rating/by-user?userId=${id}`});
  const removeUserById = (userId: number) => deleteRequest({url: API + `user/delete/admin/${userId}`, body: {reason: 'reason'}});
  const changeUserRating = (id: string, body: any) => patch({url: API + `user/rating/${id}`, body: body});

  return {
    getUserAll,
    getUserById,
    getPaginatedUsers,
    changeUserDetail,
    getRatingByUser,
    removeUserById,
    changeUserRating
  };
};

export const RatingApi = (): any => {
  const { get, patch, deleteRequest } = RestClient();
  const getRatingAll = () => get({url: API + 'rating'});
  const getPaginatedRatings = (page: number, pageSize: number, toUserId?: string, params?: any) => get({url: API +
    `rating?pageNumber=${page}&pageSize=${pageSize}` +
    `${toUserId ? '&toUserId=' + toUserId : ''}` +
    `${params?.description ? '&description=' + params.description : ''}` +
    `${params?.rate ? '&rate=' + params.rate : ''}` +
    `${params?.createdOnFrom ? '&createdOnFrom=' + params.createdOnFrom : ''}` +
    `${params?.createdOnTo ? '&createdOnTo=' + params.createdOnTo : ''}` +
    `${params?.fromUser ? '&fromUser=' + params.fromUser : ''}` +
    `${params?.toUser ? '&toUser=' + params.toUser : ''}`
  });
  const changeRating = (data: any) => patch({url: API + 'rating', body: data});
  const deleteRating = (id: number) => deleteRequest({url: API + `rating/${id}`});

  return {
    getRatingAll,
    getPaginatedRatings,
    changeRating,
    deleteRating
  };
};

export const PopularCities = (): any => {
  const { get, post, deleteRequest, patch } = RestClient();
  const getPopularCitiesAll = () => get({url: API + 'popular-city'});
  const createPopularCity = (body: {placeId: string; imageUrl: string}) => post({url: API + 'popular-city', body: body});
  const deletePopularCityById = (id: number) => deleteRequest({url: API + `popular-city/${id}`});
  const changeImage = (body: {id: number; imageUrl: string}) => patch({url: API + `popular-city/image-url/change`, body: body});

  return {
    getPopularCitiesAll,
    createPopularCity,
    deletePopularCityById,
    changeImage
  };
};

export const ProfileClient = (): any => {
  const { get, patch } = RestClient();
  const getProfileDefaults = () => get({url: API + `profile`});
  const changeProfileCurrency = (body: {id: string; currency: number}) => patch({url: API + `profile`, body});

  return {
    getProfileDefaults,
    changeProfileCurrency
  };
};

export const DealApi = (): any => {
  const { get, patch } = RestClient();
  const getDeals = () => get({url: API + `offer/deal`});
  const changeSmtng = (body: {id: string; currency: number}) => patch({url: API + `transaction`, body});

  return {
    getDeals,
    changeSmtng
  };
};

export const NotificationsApi = (): any => {
  const { get, patch } = RestClient();
  const getNotifications = () => get({url: API + `notification/unread`});
  const getNotificationsCount = () => get({url: API + `notification/unread-count`});
  const getNotificationsByType = (type: string) => get({url: API + `notification/by-type/${type}`});
  const markNotificationsAsRead = (id: number) => patch({url: API + `notification/mark-read/${id}`});

  return {
    getNotifications,
    getNotificationsByType,
    getNotificationsCount,
    markNotificationsAsRead
  };
};

export const SettingsApi = (): any => {
  const { get, put } = RestClient();
  const getCommission = () => get({url: API + `settings/percent-commission`});
  const setCommission = (commision: number) => put({url: API + `settings/percent-commission`, body: { commision }});

  return {
    getCommission,
    setCommission
  };
};

export const PlaceDetails = (): any => {
  const getPlaceDetails = (placeId: string) => {
    const stored = localStorage.getItem(placeId);
    const lang = localStorage.getItem('language') ?? 'ru';
    const parsedObj = stored ? JSON.parse(stored) : {};
    if (parsedObj[lang]) return Promise.resolve(parsedObj[lang]);
    else {
      return new Promise((resolve, reject) => {
        const service = new google.maps.places.PlacesService(document.createElement('div'));
        const request = {
          placeId,
          fields: ["name", "formatted_address", "place_id"],
          language: lang
        }
        service.getDetails(request, (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && place) {
            resolve({
              name: place.name,
              placeId: place.place_id,
              fullAddress: place.formatted_address
            });
          } else if (status === google.maps.places.PlacesServiceStatus.INVALID_REQUEST) {
            resolve({
              name: 'unknown',
              placeId,
              fullAddress: 'unknown address'
            })
          } else {
            reject(new Error(`Error fetching place details: ${status}`));
          }
        });
      }).then(res => {
        localStorage.setItem(placeId, JSON.stringify({...parsedObj, [lang]: res}));
        return res;
      });
    };
  };

  return {
    getPlaceDetails
  }
}
